import { CommonModule } from "@angular/common";
import { Component, Input } from "@angular/core";

@Component({
  selector: "app-data-card",
  imports: [CommonModule],
  templateUrl: "./data-card.component.html",
  styleUrl: "./data-card.component.scss",
})
export class DataCardComponent {
  @Input({ required: true }) icon!: "currency" | "wallet" | "ticket";
  @Input({ required: true }) title: string = "";
  @Input({ required: true }) data: string = "";
  @Input() size: "small" | "large" = "large";
  @Input() collapsibleInfo?: string;
  // Inverte as cores do ícone: fundo roxo + cifrão amarelo.
  @Input() inverted = false;

  isExpanded = false;

  toggleCollapse() {
    this.isExpanded = !this.isExpanded;
  }
}
